export default "__VITE_ASSET__Bu6EL0of__"